import React from 'react';
import { Droplets, Facebook, Twitter, Linkedin, Instagram, ArrowRight } from 'lucide-react';
import { brands } from '../mock';

export default function Footer() {
  return (
    <footer className="relative bg-slate-950 text-slate-300 pt-20 pb-8 overflow-hidden">
      <div className="absolute inset-0 opacity-20" style={{ backgroundImage: 'radial-gradient(circle at 20% 0%, rgba(14,165,233,0.4), transparent 40%), radial-gradient(circle at 80% 100%, rgba(6,182,212,0.3), transparent 40%)' }} />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
        {/* Trusted by */}
        <div className="mb-16">
          <div className="text-center text-xs tracking-[0.3em] text-slate-500 uppercase mb-6">Trusted by leading hospitality & marine brands</div>
          <div className="flex flex-wrap items-center justify-center gap-x-10 gap-y-4">
            {brands.map(b => (
              <div key={b} className="font-display text-lg font-medium text-slate-400 hover:text-white transition-colors">{b}</div>
            ))}
          </div>
        </div>

        <div className="grid lg:grid-cols-4 gap-10 pb-14 border-b border-white/10">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3">
              <div className="w-11 h-11 rounded-full bg-gradient-to-br from-sky-400 to-cyan-500 flex items-center justify-center">
                <Droplets className="w-5 h-5 text-white" strokeWidth={2.5} />
              </div>
              <div>
                <div className="font-display text-2xl font-bold text-white">Upgrade<span className="water-text">Water</span></div>
                <div className="text-[10px] tracking-[0.2em] text-sky-400/80 uppercase">Air • to • Water</div>
              </div>
            </div>
            <p className="mt-5 text-sm text-slate-400 max-w-md leading-relaxed">
              Atmospheric water generators engineered for the world’s finest hotels, resorts and
              yachts. Sustainable. Silent. Endlessly refreshing.
            </p>
            <form onSubmit={(e) => e.preventDefault()} className="mt-6 flex max-w-md">
              <input type="email" placeholder="Get updates from Upgrade Water" className="flex-1 h-11 px-4 rounded-l-full bg-white/5 border border-white/10 text-sm text-white placeholder:text-slate-500 focus:outline-none focus:border-sky-400" />
              <button className="h-11 px-5 rounded-r-full bg-gradient-to-r from-sky-500 to-cyan-600 text-white text-sm font-medium flex items-center gap-2 hover:from-sky-600 hover:to-cyan-700 transition-all">
                Subscribe <ArrowRight className="w-4 h-4" />
              </button>
            </form>
          </div>

          <div>
            <div className="text-white font-semibold mb-4">Explore</div>
            <ul className="space-y-2 text-sm">
              <li><a href="#home" className="hover:text-white transition-colors">Home</a></li>
              <li><a href="#products" className="hover:text-white transition-colors">Product Range</a></li>
              <li><a href="#how" className="hover:text-white transition-colors">Technology</a></li>
              <li><a href="#hotels" className="hover:text-white transition-colors">For Hotels</a></li>
              <li><a href="#yachts" className="hover:text-white transition-colors">For Yachts</a></li>
            </ul>
          </div>

          <div>
            <div className="text-white font-semibold mb-4">Contact</div>
            <ul className="space-y-2 text-sm">
              <li>hospitality@upgradewater.com</li>
              <li>+91 1800 UPGRADE</li>
              <li>Mumbai • Monaco • Dubai</li>
            </ul>
            <div className="mt-5 flex items-center gap-3">
              {[Facebook, Twitter, Linkedin, Instagram].map((Ic, i) => (
                <a key={i} href="#" className="w-9 h-9 rounded-full bg-white/5 border border-white/10 hover:bg-sky-500 hover:border-sky-500 flex items-center justify-center transition-all">
                  <Ic className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="pt-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-slate-500">
          <div>© {new Date().getFullYear()} Upgrade Water. All rights reserved.</div>
          <div className="flex items-center gap-5">
            <a href="#" className="hover:text-white">Privacy</a>
            <a href="#" className="hover:text-white">Terms</a>
            <a href="#" className="hover:text-white">Warranty</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
